import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import Reveal from "@/components/base/Reveal";
import { faqs } from "@/mocks/film";

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="scroll-mt-32 bg-background-50 py-14 md:py-20">
      <div className="px-4 md:px-6">
        <Reveal>
          <SectionHeading
            index="09 / 常见问题"
            title="关于这部片，最常被问到的几个问题"
            desc="以下是观众在了解《漂亮的小姨子》时问得最多的几个问题，包含故事梗概、题材定位、人物数量与观看提示。点击问题即可展开回答。"
          />
        </Reveal>

        <div className="mt-8 md:mt-10 max-w-3xl space-y-3">
          {faqs.map((faq, index) => {
            const isOpen = openIndex === index;
            return (
              <Reveal key={faq.q} delay={index * 50}>
                <div className="rounded-lg bg-background-100 border border-background-200 overflow-hidden">
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                      aria-expanded={isOpen}
                    >
                      <span className="font-heading text-base md:text-[17px] font-semibold text-foreground-950">
                        {faq.q}
                      </span>
                      <span
                        className={`shrink-0 w-8 h-8 rounded-full flex items-center justify-center text-lg transition-colors ${
                          isOpen
                            ? "bg-primary-500 text-background-50"
                            : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        <i className={isOpen ? "ri-subtract-line" : "ri-add-line"} aria-hidden="true" />
                      </span>
                    </button>
                  </h3>
                  <div className={`px-5 pb-5 -mt-1 text-sm leading-relaxed text-foreground-600 ${isOpen ? "" : "hidden"}`}>
                    {faq.a}
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}